
  export const LoginRouteAction = (loginUrl) => ({
    type: 'Login_URL',
    payload: {
        loginUrl: loginUrl
    }
  });